import React from 'react';

// Shared on/off switch (green track when on), extracted from TripFormPage when
// the booked toggles landed in the stop/leg sheets (2026-08-24). Use for a
// boolean the user sets directly; for a status *display* see PlannedPill.
const Switch: React.FC<{ on: boolean; onToggle: () => void; ariaLabel: string; disabled?: boolean }> = ({ on, onToggle, ariaLabel, disabled }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={ariaLabel}
    disabled={disabled}
    onClick={onToggle}
    style={{
      position: 'relative', width: 46, height: 27, borderRadius: 999, border: 'none',
      cursor: disabled ? 'default' : 'pointer', flexShrink: 0, opacity: disabled ? 0.5 : 1,
      background: on ? '#157a55' : '#dfe5e1', transition: 'background .15s',
    }}
  >
    <span
      style={{
        position: 'absolute', top: 3, left: on ? 22 : 3, width: 21, height: 21, borderRadius: '50%',
        background: '#fff', boxShadow: '0 1px 3px rgba(20,40,30,0.25)', transition: 'left .15s',
      }}
    />
  </button>
);

export default Switch;
